import "../../styles/home.scss";
import { FormattedMessage } from "react-intl";

const Reference = () => {
  return (
    <div className="roi--reference-container">
      <span>
        <FormattedMessage id="reference" />
      </span>
      <span>
        1. <FormattedMessage id="refText1" />
      </span>
      <span>
        2. <FormattedMessage id="refText2" />
      </span>
    </div>
  );
};

export default Reference;
